import styles from "./BadgeText.module.css";
import classNames from "classnames";

const BadgeText = ({ children, className }) => {
  return <span className={classNames(styles.badgeText)}>{children}</span>
}

export default BadgeText;
